import { useEffect } from "react";
import { PANEL, StrokeIcon } from "./ui";

/** A transient toast in the top-right corner; it clears itself after 3s. */
const Notification = ({ setShowNotification, message, isError }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowNotification(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [setShowNotification]);

  return (
    <div
      role="status"
      className={`fixed right-4 top-20 z-[80] flex items-center gap-2.5 px-4 py-3 ${PANEL} ${
        isError ? "border-rose-500/50" : "border-emerald-500/50"
      }`}
    >
      <span className={isError ? "text-rose-500" : "text-emerald-500"}>
        <StrokeIcon className="h-5 w-5">
          {isError ? (
            <>
              <circle cx="12" cy="12" r="9" />
              <path d="M12 8v4M12 16h.01" />
            </>
          ) : (
            <path d="M20 6 9 17l-5-5" />
          )}
        </StrokeIcon>
      </span>
      <p className="text-sm font-semibold text-gray-800 dark:text-slate-200">{message}</p>
    </div>
  );
};

export default Notification;
